import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const allProducts = [
  { cls:'p1', label:'Masif Mobilya', title:'Oturma Odası Takımı', sub:'Ceviz Masif', cat:'mobilya', desc:'El yapımı masif ceviz ahşabından üretilmiş, zamansız tasarımıyla öne çıkan oturma odası takımı.' },
  { cls:'p2', label:'Parke', title:'Meşe Parke', sub:'Doğal Meşe', cat:'parke', desc:'15mm kalınlığında doğal meşe parke. Yüksek trafik alanları için ideal, uzun ömürlü zemin kaplaması.' },
  { cls:'p3', label:'Duvar Kaplama', title:'Ahşap Duvar Paneli', sub:'Ladin & Gürgen', cat:'kaplama', desc:'Dekoratif iç mekan duvar ve tavan kaplamalarında kullanılan yatay lamelli panel sistemi.' },
  { cls:'p4', label:'Kapı', title:'Masif İç Kapı', sub:'Ceviz Masif', cat:'kapi', desc:'Tam masif cevizden üretilen, akustik yalıtımlı iç mekan kapısı. Her ölçüde üretilebilir.' },
  { cls:'p1', label:'Masif Mobilya', title:'Yemek Masası', sub:'Meşe Masif', cat:'mobilya', desc:'200x100cm masif meşe yemek masası. Her ailenin sofrasına yakışan sade ve güçlü tasarım.' },
  { cls:'p2', label:'Parke', title:'Laminat Parke', sub:'Kayın Laminat', cat:'parke', desc:'12mm yüksek yoğunluklu laminat parke. Kolay montaj ve bakım kolaylığıyla öne çıkar.' },
  { cls:'p3', label:'Tavan Kaplama', title:'Tavan Lambri', sub:'Çam Lambri', cat:'kaplama', desc:'Rustik ve modern iç mekanlara uygun çam lambri. Farklı renk seçenekleriyle mevcuttur.' },
  { cls:'p4', label:'Pencere', title:'Ahşap Pencere', sub:'Meşe & Alüminyum', cat:'kapi', desc:'Ahşap-alüminyum kompozit pencere sistemi. Yüksek yalıtım ve uzun ömür.' },
  { cls:'p1', label:'Masif Mobilya', title:'Yatak Odası Takımı', sub:'Wenge Masif', cat:'mobilya', desc:'Wenge masif ahşaptan üretilen 5 parça yatak odası takımı. Lüks ve kalıcı bir yatırım.' },
];

const filters = [
  { key: 'hepsi', label: 'Tümü' },
  { key: 'mobilya', label: 'Mobilya' },
  { key: 'parke', label: 'Parke & Zemin' },
  { key: 'kaplama', label: 'Duvar & Tavan' },
  { key: 'kapi', label: 'Kapı & Pencere' },
];

export default function Urunler() {
  const [active, setActive] = useState('hepsi');

  const filtered = active === 'hepsi'
    ? allProducts
    : allProducts.filter(p => p.cat === active);

  return (
    <>
      <div className="page-hero">
        <div className="page-hero-content">
          <div className="page-hero-tag">Ürünlerimiz</div>
          <h1>Doğanın En Güzel<br /><em>Koleksiyonları</em></h1>
        </div>
      </div>

      <section className="section">
        <div className="section-tag">Koleksiyonlarımız</div>
        <div className="products-header">
          <div className="section-title">Tüm Ürünler</div>
          <Link to="/iletisim" className="btn-dark">Özel Teklif Al</Link>
        </div>

        {/* FİLTRE */}
        <div className="filter-bar">
          {filters.map(f => (
            <button
              key={f.key}
              className={`filter-btn ${active === f.key ? 'active' : ''}`}
              onClick={() => setActive(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="products-page-grid">
          {filtered.map((p, i) => (
            <div className="product-page-card" key={i}>
              <div className="product-page-img">
                <div className={`product-page-color ${p.cls}`}>
                  <h3>{p.title}</h3>
                  <p>{p.sub}</p>
                </div>
              </div>
              <div className="product-page-info">
                <p>{p.desc}</p>
                <span className="tag">{p.label}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ÖZEL SİPARİŞ */}
      <section className="section about-bg">
        <div style={{maxWidth:'640px', margin:'0 auto', textAlign:'center'}}>
          <div className="section-tag">Özel Üretim</div>
          <div className="section-title">Hayalinizdeki Ürün<br />Listede Yok mu?</div>
          <p style={{color:'var(--text-muted)', fontSize:'16px', lineHeight:'1.8', marginTop:'16px'}}>
            Her ürünü özel ölçü ve tasarımda üretebiliyoruz. Bize ihtiyacınızı anlatın,
            size en uygun çözümü birlikte tasarlayalım.
          </p>
          <div style={{marginTop:'40px'}}>
            <Link to="/iletisim" className="btn-dark">Özel Sipariş Ver</Link>
          </div>
        </div>
      </section>
    </>
  );
}
